module.exports = __webpack_public_path__ + "static/media/sapin0419.861ba9c7.jpg";